import _ from 'lodash';

export default function getNewPets(pets) {
	return _.filter(pets, 'isNew');
}



// WEBPACK FOOTER //
// ./src/selectors/getNewPets.js